import { render, staticRenderFns } from "./CsvDataTable.vue?vue&type=template&id=1682fe9b&scoped=true&"
import script from "./CsvDataTable.vue?vue&type=script&lang=ts&"
export * from "./CsvDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./CsvDataTable.vue?vue&type=style&index=0&id=1682fe9b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1682fe9b",
  null
  
)

export default component.exports